export const SUBCONTRACTORS_ENDPOINT = 'winter-service-subcontractors'

// Operators (izvršitelji) always hang under their subcontractor - the backend has
// no route that reaches one without it.
export const buildOperatorsEndpoint = (subcontractorId) => `${SUBCONTRACTORS_ENDPOINT}/${subcontractorId}/operators`

export const SUBCONTRACTORS_TABLE_KEY = 'winter-service-v2-subcontractors'
export const SUBCONTRACTORS_UI_VIEW = 'winter_service2_subcontractors'

export const OPERATORS_TABLE_KEY = 'winter-service-v2-subcontractor-operators'

export const SUBCONTRACTORS_INDEX_ROUTE = 'WinterService2Subcontractors'
export const SUBCONTRACTOR_DETAILS_ROUTE = 'WinterService2SubcontractorDetails'

export const SUBCONTRACTORS_TRANSLATION_NAMESPACE = 'road-maintenance/winter_service2/subcontractors'
